<div class="rich-text-area">
  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
  <ngx-editor [editor]="editor" [placeholder]="placeholder"
  [(ngModel)]="value" (ngModelChange)="onChange($event)" [disabled]="disabled"></ngx-editor>
</div>